export default __webpack_public_path__ + "static/media/OUFinal3.28bd99d3.png";